import React from 'react';

import DateRangeContainer from '@totem/components/common/dateRangePicker/dateRangeContainer';
import BillingContainer from '@totem/components/ticketing/billing/billingContainer';
import UnbilledPane from '@totem/components/ticketing/billing/unbilledPane';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const BillingPage = () => {
  return (
    <ContentLayout pageTitle="Billing" contentRight={<span />}>
      <IBCard isCovered>
        <DateRangeContainer defaultTimeFrame={'week'} allowClear>
          <BillingContainer>
            <UnbilledPane />
          </BillingContainer>
        </DateRangeContainer>
      </IBCard>
    </ContentLayout>
  );
};

export default BillingPage;
